import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface DateTimeDisplayProps {
  created_at?: string;
  last_login?: string;
  dBlock?: boolean;
}

const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({ created_at, last_login, dBlock }) => {
  const { t } = useTranslation();
  const datHour = moment(created_at || last_login);
  const date = datHour.format('DD-MM-YYYY');
  const hour = datHour.format('HH:mm:ss');
  const classCustom = `fs-6 ${dBlock ? 'd-block' : ''}`;

  return (
    <ul className="list-group-item">
      <li className="list-group-item">
        <div className="d-flex flex-column">
          <div className="mb-1">
            <strong className={classCustom}>{t('general.date')}:</strong>
            <span>{date}</span>
          </div>
          <div className="mb-1">
            <strong className={classCustom}>{t('general.hour')}:</strong>
            <span>{hour}</span>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default DateTimeDisplay;
